const AboutUsInfo = ({ header, body, extraBody, textColor, list, pfont }) => {
  return (
    <div className="mb-8">
      <p className='text-[20px] font-bold uppercase'>{header}</p>
      <div className='my-4'>
        <p className={`${textColor} ${pfont || "text-[18px]"} font-normal`}>{body}</p>
        {extraBody && (<p className={`${textColor} text-[18px] mt-2 font-normal`}>{extraBody}</p>)}
        {
          list && (
            <ul className='text-[#7A7A7A] list-disc'>
              {list.map((item, index) => (
                <li key={index} className='py-2 text-[18px]'>{item}</li>
              ))}
            </ul>
          )
        }
      </div>
    </div>
  )
}

export default AboutUsInfo